module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Sutaupykite daugiau su išmaniąja įranga","paragraph":"Mūsų siūloma išmani optimizuota sistema užtikrina iki 25% efektyvesnį elektrinės darbą, lankstesnes modulių išdėstymo galimybes ir didesnį saugumą. Daugiau apie optimizuotą įrangą sužinokite pažiūrėję informacinį vaizdo klipą:","cta":"Gaukite pasiūlymą"}}')
  delete Component.options._Ctor
}
